export const hashSeed = (value) => {
  const text = (value ?? '').toString();
  let hash = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

export const createSeededRandom = (seed) => {
  let t = seed >>> 0;
  return () => {
    t += 0x6D2B79F5;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
};

export const samplePoisson = (lambda, randomFn = Math.random) => {
  if (!Number.isFinite(lambda) || lambda <= 0) return 0;
  if (lambda < 30) {
    const limit = Math.exp(-lambda);
    let k = 0;
    let p = 1;
    while (p > limit) {
      k += 1;
      p *= randomFn();
    }
    return Math.max(0, k - 1);
  }
  const u1 = randomFn();
  const u2 = randomFn();
  const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  return Math.max(0, Math.round(lambda + Math.sqrt(lambda) * z));
};

export const sampleBinomial = (trials, p, randomFn = Math.random) => {
  const n = Math.max(0, Math.floor(trials));
  if (n === 0) return 0;
  if (p <= 0) return 0;
  if (p >= 1) return n;
  if (n < 50) {
    let count = 0;
    for (let i = 0; i < n; i += 1) {
      if (randomFn() < p) count += 1;
    }
    return count;
  }
  const mean = n * p;
  const variance = n * p * (1 - p);
  if (variance === 0) return Math.round(mean);
  const u1 = randomFn();
  const u2 = randomFn();
  const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  const sample = Math.round(mean + Math.sqrt(variance) * z);
  return Math.max(0, Math.min(n, sample));
};
